// src/modules/assetManagement/management/ManagedAssetPage.tsx
// An asset opened from Asset Management: same asset view, with management breadcrumbs and actions.
import React from "react";
import { FolderCog } from "lucide-react";
import AssetDetail from "../library/AssetDetail";

const ManagedAssetPage: React.FC = () => (
  <div className="max-w-[1500px] mx-auto">
    <div className="flex items-center gap-3 mb-6">
      <div className="w-11 h-11 rounded-xl bg-slate-200 text-slate-700 flex items-center justify-center">
        <FolderCog size={22} />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Asset Management</h1>
        <p className="text-sm text-slate-500">Upload, fix, archive, share and delete your files</p>
      </div>
    </div>
    <AssetDetail context="management" />
  </div>
);

export default ManagedAssetPage;
